import { PTag } from "@porsche-design-system/components-react"
import type { PTagProps } from "@porsche-design-system/components-react"
import type { NotificationListItem } from "@slfinrtl/ui-bff-routes"
import { useMemo } from "react"
import { CopyToClipboardInsideTag } from "src/components"

interface NotificationListItemMetaTag {
	canBeCopied?: boolean
	compact?: boolean
	message: string
	metaMessageKey: string
	notificationTypeKey: NotificationListItem["notificationTypeKey"]
	severity: NotificationListItem["severity"]
}

export const NotificationListItemMetaTag = ({
	canBeCopied,
	compact,
	message,
	metaMessageKey,
	notificationTypeKey,
	severity,
}: NotificationListItemMetaTag) => {
	const variant = useMemo<PTagProps["variant"]>(() => {
		const isMainMetaTag = notificationTypeKey.endsWith(`.${metaMessageKey}`)
		return isMainMetaTag ? mapNotificationTypeKeyToTagVariant[severity] : undefined
	}, [metaMessageKey, notificationTypeKey, severity])

	return (
		<PTag compact={compact} variant={variant}>
			{canBeCopied ? <CopyToClipboardInsideTag value={message} /> : message}
		</PTag>
	)
}

const mapNotificationTypeKeyToTagVariant: Record<NotificationListItem["severity"], PTagProps["variant"]> = {
	critical: "error",
	high: "warning",
	warning: "warning-frosted",
}
